import {
  useAssemblyImageCaptionMutation,
  GetAssemblyDetailsDocument,
} from '@/__generated__/graphql';

export function useAssemblyAttachmentCaption() {
  const [assemblyImageCaption, { data, loading, error }] = useAssemblyImageCaptionMutation();

  const updateAssemblyAttachmentCaption = async (
    assemblyAttachmentId: string,
    caption?: string,
    assemblyId?: string,
    uuid?: string
  ) => {
    if (!assemblyId) throw new Error('AssemblyId is required');
    if (!caption) return;
    return assemblyImageCaption({
      variables: {
        input: {
          assemblyId,
          assemblyAttachmentId,
          caption,
          uuid,
          lastModifiedFor: 'Update attachment caption',
        },
      },
      refetchQueries: [GetAssemblyDetailsDocument],
    });
  };

  return { updateAssemblyAttachmentCaption, data, loading, error };
}
